import { Outlet } from "react-router-dom";
import classNames from "classnames";
import PageState from "../components/PageState";
import SideBar from "../components/sidebar/SideBar";
import Header from "../components/header/Header";
import Notification from "../components/notification/Notification";
import { useGlobalState } from "../GlobalContext";
import { useHasScrollbar } from "../js/scrolling";

function DefaultLayout() {
  const globalState = useGlobalState();
  const hasScrollbar = useHasScrollbar();

  return (
    <>
      <PageState />
      <Header />
      <main
        className={classNames(
          globalState.showNavigation ? "sidebar-expanded" : ""
        )}
      >
        <SideBar />
        <div
          id="content"
          className={classNames(
            hasScrollbar ? "has-scrollbar" : "has-no-scrollbar"
          )}
        >
          <Outlet />
        </div>
        <Notification />
      </main>
    </>
  );
}

export default DefaultLayout;
